export default "__VITE_ASSET__DjXEgEwi__"